export default __webpack_public_path__ + "static/media/Try_out_the_free_version.4bf0e17d.png";